import axios, { AxiosResponse } from 'axios';

import apiPaths from 'enums/apiPaths';

interface IRegistrace {
    jmeno: string;
    prijmeni: string;
    email: string;
    telefon: string;
    password: string;
    lang: string;
    captid: number;
    value: string;
    majetkovyucet?: string;
    leimigraceid?: string;
}

export interface IRegResponse {
    email: 'STEJNY' | 'RUZNY';
}

const registrace = (props: IRegistrace) => {
    return axios({
        method: 'POST',
        url: apiPaths.REGISTRACE,
        data: props
    }).then((resp: AxiosResponse<IRegResponse>) => resp.data);
};
export default registrace;
